export default __webpack_public_path__ + "static/media/galeria6.6715c613.png";